import { render, staticRenderFns } from "./ProposalNumberTooltip.vue?vue&type=template&id=0d62aa61&scoped=true"
import script from "./ProposalNumberTooltip.vue?vue&type=script&lang=js"
export * from "./ProposalNumberTooltip.vue?vue&type=script&lang=js"
import style0 from "./ProposalNumberTooltip.vue?vue&type=style&index=0&id=0d62aa61&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d62aa61",
  null
  
)

export default component.exports